module.exports = __webpack_public_path__ + "static/media/Dashboard-selected-icon.3061eaf0.svg";